
import Vue from "vue";
export default Vue.extend({
  functional: true,
  render(h, ctx) {
    return ctx.children;
  }
});
